import script from "./RecordSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecordSummary.vue?vue&type=script&setup=true&lang=ts"

import "./RecordSummary.vue?vue&type=style&index=0&id=0490d33e&scoped=true&lang=css"

import exportComponent from "E:\\Sites\\mk64\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0490d33e"]])

export default __exports__